import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectSensorDataSession = (state: AppState) => state.sensorDataSession;

export const getSensorDataSessions = () => createSelector(selectSensorDataSession, (state) => state.sessions);
export const getSensorDataSessionsTotal = () => createSelector(selectSensorDataSession, (state) => state.sessionsTotal);
export const getSensorDataSession = () => createSelector(selectSensorDataSession, (state) => state.current_session);
export const getFilter = () => createSelector(selectSensorDataSession, (state) => state.filter);
export const getFilesUploadingPercentage = () =>
  createSelector(selectSensorDataSession, (state) => state.files_perscentage);
export const getCurrentSessionValues = () =>
  createSelector(selectSensorDataSession, (state) => state.current_session_values);
export const getCurrentSessionProcessedValues = () =>
  createSelector(selectSensorDataSession, (state) => state.current_session_processed_values);
export const getCurrentSessionValuesFilter = () =>
  createSelector(selectSensorDataSession, (state) => state.current_session_values_filter);

export const getCurrentSessionMarkers = () =>
  createSelector(selectSensorDataSession, (state) => state.current_session_markers);

export const getCurrentSessionDots = () =>
  createSelector(selectSensorDataSession, (state) => state.current_session_dots);
